import idb from '@/idb'
import * as types from '../mutation-types'
import { isOffline } from '@/helpers/offline-simulation'

const persist = (queue) => idb.write(idb.objects.syncQueue, { items: queue }).catch(() => {})

let onlineListenerRegistered = false

export default {
	namespaced: true,

	state: {
		queue: [],
		isSyncing: false
	},

	actions: {
		init({ commit, dispatch }) {
			return idb.read(idb.objects.syncQueue).then((record) => {
				commit(types.STORE_QUEUE, record?.items || [])
				if (onlineListenerRegistered) return
				onlineListenerRegistered = true
				window.addEventListener('online', () => dispatch('flushQueue'))
			})
		},

		enqueue({ commit, state }, { visitPayload, orderPayload }) {
			const localId = `visit-${Date.now()}-${Math.random().toString(36).slice(2)}`
			const item = {
				localId,
				visitPayload,
				orderPayload: orderPayload || null,
				createdAt: Date.now(),
				status: 'pending',
				errorMessage: null
			}

			const queue = [...state.queue, item]
			commit(types.STORE_QUEUE, queue)
			return persist(queue).then(() => localId)
		},

		attachOrder({ commit, state }, { localId, orderPayload }) {
			commit(types.UPDATE_QUEUE_ITEM, { localId, changes: { orderPayload } })
			return persist(state.queue)
		},

		flushQueue({ commit, state }) {
			if (isOffline() || state.isSyncing || !state.queue.length) return Promise.resolve()

			commit(types.SET_SYNCING, true)

			const pendingItems = state.queue.filter((item) => item.status === 'pending')

			return pendingItems.reduce((chain, item) => {
				return chain.then(() => {
					return window.axios.post('/visits/createvisit', item.visitPayload)
						.then((visitResponse) => {
							const createdVisitId = visitResponse?.data
							if (!item.orderPayload || !item.orderPayload.orderDetail?.length) return null

							const orderPayload = { ...item.orderPayload, visitId: createdVisitId }
							return window.axios.post('/order', orderPayload)
						})
						.then(() => {
							commit(types.REMOVE_QUEUE_ITEM, { localId: item.localId })
							return persist(state.queue)
						})
						.catch((error) => {
							// خطأ شبكة: نتوقف عن المعالجة الآن ونحاول مجدداً في المرة القادمة
							if (!error.response) return Promise.reject(error)

							// خطأ من الخادم (بيانات غير صالحة مثلاً): تُعلَّم كخطأ ولا تُوقف بقية الطابور
							commit(types.UPDATE_QUEUE_ITEM, {
								localId: item.localId,
								changes: {
									status: 'error',
									errorMessage: error.response.data?.message || 'error'
								}
							})
							return persist(state.queue)
						})
				})
			}, Promise.resolve())
				.catch(() => {})
				.finally(() => commit(types.SET_SYNCING, false))
		},

		removeFromQueue({ commit, state }, { localId }) {
			commit(types.REMOVE_QUEUE_ITEM, { localId })
			return persist(state.queue)
		}
	},

	mutations: {
		[types.STORE_QUEUE](state, queue) {
			state.queue = queue
		},

		[types.UPDATE_QUEUE_ITEM](state, { localId, changes }) {
			state.queue = state.queue.map((item) => item.localId === localId ? { ...item, ...changes } : item)
		},

		[types.REMOVE_QUEUE_ITEM](state, { localId }) {
			state.queue = state.queue.filter((item) => item.localId !== localId)
		},

		[types.SET_SYNCING](state, isSyncing) {
			state.isSyncing = isSyncing
		}
	},

	getters: {
		pendingCount: state => state.queue.length
	}
}
